import * as z from "zod/v4";

export const onboardingV2AnalyticsProductIdSchema = z.enum([
  "returns",
  "order-editing",
]);

export const onboardingV2HideArchivedInputSchema = z.object({
  hideArchived: z.boolean().default(true),
});

export const onboardingV2AnalyticsProductInputSchema =
  onboardingV2HideArchivedInputSchema.extend({
    productId: onboardingV2AnalyticsProductIdSchema.optional(),
  });

/**
 * Scope for the overview analytics page. "all" aggregates every
 * admin-visible product (see V2_ADMIN_PRODUCTS). Individual product
 * scopes filter down to a single product.
 *
 * Note: this is a different enum from `onboardingV2AnalyticsProductIdSchema`
 * (which covers returns + order-editing only) because the overview page
 * surfaces all admin-visible products, while the per-product analytics
 * pages (e.g. returns analytics, OMS analytics) are product-specific and
 * intentionally narrow.
 */
export const onboardingV2OverviewProductScopeSchema = z.enum([
  "all",
  "returns",
  "order-editing",
  "recover",
  "chargebacks",
]);

export const onboardingV2ReturnsRevenueModeSchema = z.enum([
  "weighted",
  "fully-onboarded",
]);

export type OnboardingV2AnalyticsProductId = z.infer<
  typeof onboardingV2AnalyticsProductIdSchema
>;
export type OnboardingV2OverviewProductScope = z.infer<
  typeof onboardingV2OverviewProductScopeSchema
>;
export type OnboardingV2ReturnsRevenueMode = z.infer<
  typeof onboardingV2ReturnsRevenueModeSchema
>;
